import { cn } from '@/utils/cn';

interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner2 = ({ className }: LoadingSpinnerProps) => {
  return (
    <div
      className={cn(
        'animate-spin flex-shrink-0 rounded-full h-4 w-4 border-[2px] border-gray-200 border-t-[#0C8DBF]',
        className
      )}
    ></div>
  );
};

export default LoadingSpinner2;
